<ion-content>
  <div class="content">
    <ion-list lines="none" mode="md" class="list">
      <ion-item lines="none" mode="md" class="ion-text-center">
        <ion-label mode="md">
          <p
            [innerHTML]="sanitizer(Params.nombre)"
            style="font-weight: bold;"
          ></p>
          <p [innerHTML]="sanitizer(Params.subtitle)"></p>
        </ion-label>
      </ion-item>
      <ion-item lines="none" mode="md">
        <ion-img class="center-elements" [src]="Params.icono"></ion-img>
      </ion-item>
      <ion-item lines="none" mode="md" class="ion-text-center">
        <ion-label
          [innerHTML]="sanitizer(Params.realizar)"
          style="font-size: 12px;"
          mode="md"
        ></ion-label>
      </ion-item>
      <ion-item lines="none" mode="md" class="ion-text-center">
        <ion-button
          (click)="onConfirm(true)"
          expand="block"
          color="darkblue"
          class="ion-text-uppercase center-elements"
          size="default"
        >
          {{ Params.aceptar }}
        </ion-button>
      </ion-item>
      <ion-item lines="none" mode="md" class="ion-text-center">
        <ion-button
          (click)="onConfirm(false)"
          fill="clear"
          class="ion-no-padding"
          color="darkblue"
          size="small"
          class="center-elements"
        >
          <span style="border-bottom: 1px solid #004a97;">
            {{ Params.denegar }}
          </span>
        </ion-button>
      </ion-item>
    </ion-list>
  </div>
</ion-content>
